import { render } from "./DigitalLearningEcosystemView.vue?vue&type=template&id=024da62d&scoped=true"
import script from "./DigitalLearningEcosystemView.vue?vue&type=script&lang=js"
export * from "./DigitalLearningEcosystemView.vue?vue&type=script&lang=js"

import "./DigitalLearningEcosystemView.vue?vue&type=style&index=0&id=024da62d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024da62d"]])

export default __exports__